import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { StorageService } from '../../../../core/services/storage.service';
import Order from '../../../../core/models/order';
import { Constants } from '../../../../core/utils/constants';
import { UtilService } from '../../../../core/services/util.service';
import { OrderService } from '../../../order/services/order.service';
import CouponType from '../../../../core/enums/couponType.enum';
import { Cover, TicketData } from 'src/app/core/models/order.details';
import {
  ExplicitCouponsType,
  ExplicitCouponType,
} from '../checkout/checkout.component';
import { getPlaces } from 'src/app/core/functions/getPlaces';
import { TicketService } from '../../services/ticket.service';
import getMobileOS from 'src/app/core/functions/getMobileOS';
import MobileOs from 'src/app/core/enums/mobile-os';
import { CalendarEvent } from 'calendar-link';
import { OrderStatus } from 'src/app/core/enums/orderStatus.enum';
import { CardType } from 'src/app/core/enums/cardType.enum';

type ParsedTicketData = {
  ticketTypeId: number;
  qty: number;
  place?: string;
  ticketTypeName: string;
  ticketsLabel: string[];
  price: number;
  blockId?: string;
  isSeat: boolean;
};

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css'],
})
export class ConfirmationComponent implements OnInit {
  public order: Order | null = null;
  public parsedTicketsData: ParsedTicketData[] = [];
  public dates: string[] = [];
  public eventName: string = '';
  public eventPlace: string = '';
  public calendarEvent!: CalendarEvent;
  public allCouponsNames: string = '';
  public totalDiscount: number = 0;

  public codeCoupons: ExplicitCouponsType<CouponType.Code> = [];
  public cardCoupon?: ExplicitCouponType<CouponType.CreditCard>;

  public actionImg = '';

  private slug!: string;

  private eventCover: string = '';

  get canAddToWallet() {
    return this.order?.slug && this.order.status !== OrderStatus.CANCELLED;
  }

  get places() {
    const _place = this.eventPlace;
    if (!_place) return ['Cargando...'];
    return getPlaces(this.eventPlace, this.parsedTicketsData);
  }

  get discounted() {
    return this.orderService.codeCouponsDiscount(this.order);
  }

  get couponsNames() {
    return this.codeCoupons.map((c) => c.code);
  }

  get totalTicketsCount(): number {
    return this.parsedTicketsData.reduce(
      (total, ticketData) => total + ticketData.qty,
      0
    );
  }

  get cardLogo() {
    let base = '/assets/img/type-';
    if (this.order?.cardType === CardType.SUPERCARD) {
      return 'https://tix-shared.s3.us-east-1.amazonaws.com/type-supercard-card.png';
    }
    return base + this.order?.cardType + '-card.png';
  }

  constructor(
    private localStorageService: StorageService,
    private utilService: UtilService,
    private orderService: OrderService,
    private ticketsService: TicketService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    const os = getMobileOS();

    if (os === MobileOs.IOS) {
      this.actionImg = 'assets/img/add-to-apple-wallet.svg';
    } else if (os !== null) {
      this.actionImg = 'assets/img/add-to-google-wallet.svg';
    }

    window.addEventListener('load', () => {
      if (this.order?.slug) {
        //this.createConfetti();
      }
    });
  }

  ngOnInit(): void {
    this.order =
      JSON.parse(
        this.localStorageService.get(Constants.Keys.OrderConfirmation) ?? ''
      ) ?? null;

    // this.order = {
    //   slug: '6ab02dfa-c71a-4195-a327-00f675c6c834',
    // } as any;
    if (!this.order?.slug) return;
    this.slug = this.order.slug;
    this.initOrder(this.order?.slug);
  }

  isWalletVisible = false;

  onWalletVisibilityChange(isVisible: boolean) {
    this.isWalletVisible = isVisible;
  }

  getImageUrl() {
    return (
      this.utilService.getAbsoluteUrl(this.eventCover) ??
      'https://static.thenounproject.com/png/1077596-200.png'
    );
  }

  async addToWallet(type: 'google' | 'apple' = 'apple') {
    const response = await this.ticketsService.addToWallet(this.slug, type);

    if (type === 'apple') {
      this.addToAppleWallet(response);
    } else if (type === 'google') {
      this.addToGoogleWallet((response as any)?.saveUrl);
    }
  }

  private async addToGoogleWallet(saveUrl?: string) {
    if (!document || !saveUrl) return;

    const link = document.createElement('a');
    link.href = saveUrl;
    link.click();

    link.remove();
    URL.revokeObjectURL(link.href);
  }

  private async addToAppleWallet(passes?: any) {
    if (!document || !passes) return;
    const link = document.createElement('a');

    const file = new Blob([passes], { type: 'application/vnd.apple.pkpasses' });
    link.href = URL.createObjectURL(file);
    link.download = 'event.pkpasses';
    link.click();
    URL.revokeObjectURL(link.href);
  }

  private async initOrder(slug: string) {
    this.orderService.getDetail(slug).subscribe((resp) => {
      if (!resp) return;
      this.order = resp as unknown as Order;
      this.parsedTicketsData = this.getParsedTicketsData(resp?.tickets);

      this.calendarEvent = {} as CalendarEvent;
      this.calendarEvent.start = this.order.event.startAt;
      this.calendarEvent.end = this.order.event.endAt;

      this.calendarEvent.description = this.order.event.description || '';
      this.calendarEvent.status = 'CONFIRMED';
      this.calendarEvent.title = this.order.event.name;

      this.eventCover = this.getCover(resp?.event?.cover);
      this.eventName = resp?.event.name || '';
      this.eventPlace = resp?.event.place || '';
      // resp?.discounts.forEach((discount) => {
      //   const coupon = discount.coupon;

      //   switch (coupon.type) {
      //     case CouponType.Code:
      //       this.codeCoupons.push(
      //         coupon as ExplicitCouponType<CouponType.Code>
      //       );
      //       break;
      //     case CouponType.CreditCard:
      //       this.cardCoupon =
      //         coupon as ExplicitCouponType<CouponType.CreditCard>;
      //       this.cardCoupon.discounted =
      //         (this.order?.subTotal || 0) * (this.cardCoupon.discount / 100);
      //       break;
      //   }
      // });
      this.totalDiscount = 0;
      this.codeCoupons = [];
      const couponNames: string[] = [];
      resp?.discounts.forEach((discount) => {
        const coupon = discount.coupon;
        if (discount.discounted) {
          this.totalDiscount += discount.discounted;
        }
        const couponLabel = coupon.name || coupon.code;
        if (couponLabel) {
          couponNames.push(couponLabel);
        }
        switch (coupon.type) {
          case CouponType.Code:
            this.codeCoupons.push(
              coupon as ExplicitCouponType<CouponType.Code>
            );
            break;
          case CouponType.CreditCard:
            this.cardCoupon =
              coupon as ExplicitCouponType<CouponType.CreditCard>;
            break;
        }
      });
      this.allCouponsNames = couponNames.join(', ');
      this.setStartDates(resp?.tickets);
      if (this.order?.slug) {
        setTimeout(() => {
          this.createConfetti();
        }, 100);
      }
    });
  }

  private setStartDates(tickets?: TicketData[]) {
    if (!tickets) return;
    tickets.forEach((ticket) => {
      const tt = ticket.ticketType;

      if (tt.start_on && !this.dates.includes(tt.start_on)) {
        this.dates.push(tt.start_on);
      }

      this.dates = this.dates.sort();

      if (this.dates.length === 0 && this.order?.event) {
        this.dates.push(this.order.event.startAt as any);
      }
    });
  }

  private getCover(covers?: Cover[]) {
    if (!covers || covers?.length === 0) return '';

    for (const cover of covers) {
      if (!cover.name.startsWith('tix_main_cover')) continue;
      return cover.url;
    }
    return covers[0].url;
  }

  private getParsedTicketsData(tickets?: TicketData[]) {
    if (!tickets) {
      return [];
    }

    const data: ParsedTicketData[] = [];

    tickets.forEach((ticket) => {
      const ticketTypeId = ticket.ticketType.id;
      let index = data.findIndex((t) => t.ticketTypeId === ticketTypeId);
      if (index < 0) {
        data.push({
          qty: 0,
          price: ticket.price ?? ticket.ticketType.price,
          place: ticket.ticketType.place,
          ticketTypeId: ticketTypeId,
          ticketTypeName: ticket.ticketType.name,
          isSeat: ticket.ticketType.isSeat,
          blockId: ticket.ticketType.block_id,
          ticketsLabel: [],
        });

        index = data.length - 1;
      }

      const isSeat = data[index].isSeat;
      const blockId = data[index].blockId;

      let label = ticket.label;
      if (blockId && isSeat) {
        if (blockId) {
          const labelPrefix = blockId.replace('_', ' ') + ' ';
          label = label.replace(/\w+_/, ``);
        }
      }

      data[index].qty++;
      data[index].ticketsLabel.push(label);
    });
    return data;
  }

  hasCoupons(): boolean {
    return this.totalDiscount > 0;
  }

  getCouponsCount(): number {
    return this.allCouponsNames.split(',').length;
  }

  getCardConfig(cardType: string | undefined) {
    const configs: { [key: string]: { color: string; label: string } } = {
      visa: { color: '#1434CB', label: 'VISA' },
      mastercard: { color: '#FF5F00', label: 'MC' },
      supercard: { color: '#808080', label: 'SC' },
    };

    return (
      configs[cardType?.toLowerCase() || ''] || { color: '#666666', label: '?' }
    );
  }

  extractCardSuffix(cardNumber: string): string {
    // return cardNumber ? `•••• ${cardNumber.slice(-4)}` : '';
    return cardNumber ? `${cardNumber.slice(-4)}` : '';
  }

  private colors = [
    '#ffd700', // Oro
    '#ff6b6b', // Rojo/Rosa
    '#4ecdc4', // Turquesa
    '#45b7d1', // Azul Claro
    '#96ceb4', // Verde Menta
    '#ff9ff3', // Rosa Púrpura
  ];
  private confettiCount = 200;
  private duration = 3500;

  createConfetti(): void {
    const container = this.el.nativeElement;
    for (let i = 0; i < this.confettiCount; i++) {
      const confetti = this.renderer.createElement('div');
      this.renderer.addClass(confetti, 'confetti');
      this.renderer.setStyle(confetti, 'left', Math.random() * 100 + '%');
      this.renderer.setStyle(
        confetti,
        'background',
        this.colors[Math.floor(Math.random() * this.colors.length)]
      );
      this.renderer.setStyle(
        confetti,
        'animation-delay',
        Math.random() * 0.5 + 's'
      );
      this.renderer.setStyle(
        confetti,
        'animation-duration',
        Math.random() * 2 + 2 + 's'
      );
      this.renderer.setStyle(confetti, 'width', Math.random() * 10 + 5 + 'px');
      this.renderer.setStyle(confetti, 'height', Math.random() * 10 + 5 + 'px');
      this.renderer.setStyle(
        confetti,
        'opacity',
        (Math.random() * 0.5 + 0.5).toString()
      );
      this.renderer.appendChild(container, confetti);
      setTimeout(() => {
        this.renderer.removeChild(container, confetti);
      }, this.duration);
    }
  }
}
